import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=fd249e4e"
import script from "./page-footer.js?vue&type=script&lang=js&external"
export * from "./page-footer.js?vue&type=script&lang=js&external"
import style0 from "./page-footer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports